"use client";

import { c as _c } from "react/compiler-runtime";
import { TaskDetailPanelContent } from "@/app/[tenant]/(console)/tasks/modals/task-detail-modal";
import { selectTaskSidebar } from "@/features/sidebar/task-sidebar";
import { useRightSidebarStore } from "@/stores/right-sidebar-store";
interface TaskSidebarPanelProps {
  onClose: () => void;
}
export function TaskSidebarPanel(t0) {
  const $ = _c(4);
  const {
    onClose
  } = t0;
  const {
    taskId
  } = useRightSidebarStore(selectTaskSidebar);
  if (!taskId) {
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <div className="flex h-full items-center justify-center px-4 text-center text-body text-foreground-secondary">No task selected</div>;
      $[0] = t1;
    } else {
      t1 = $[0];
    }
    return t1;
  }
  let t1;
  if ($[1] !== onClose || $[2] !== taskId) {
    t1 = <TaskDetailPanelContent taskId={taskId} onClose={onClose} showCloseButton={false} className="h-full w-full min-w-0 flex-1" />;
    $[1] = onClose;
    $[2] = taskId;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
}